import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const setupStats = (el) => {
  const counts = el.querySelectorAll('[data-count]')

  counts.forEach((count) => {
    gsap.to(count, {
      scrollTrigger: {
        trigger: el,
        start: 'top center',
        once: true,
      },
      yPercent: `-${parseInt(count.getAttribute('data-count')) * 100}`,
      duration: 3,
      ease: 'power2.out',
    })
  })
}

export default setupStats
